
import { useEffect, useState } from 'react'

import { Button, Icon, Label, Select, Table } from 'semantic-ui-react'

import { DropdownOptions } from '../../constants'

import { LoadingSpinner, ErrorMessage, NoData } from '../../components'

import { Agency } from '../../models'

import { AgencyService, HelperService } from '../../services'

export function AdminsysAgenciesPage() {

    const [agencies, setAgencies] = useState<Agency[]>([])
    const [loadingAgencies, setLoadingAgencies] = useState<boolean>(true)
    const [errorFetchingAgencies, setErrorFetchingAgencies] = useState<boolean>(false)

    useEffect(() => {

        const storedAgencies = HelperService.retrieveAgencies()

        if (storedAgencies.length > 0) {
            setAgencies(storedAgencies)
            setLoadingAgencies(false)
            return
        }

        AgencyService.getAgenciesList('sys')
            .then(data => setAgencies(data))
            .catch(err => setErrorFetchingAgencies(true))
            .finally(() => setLoadingAgencies(false))

    }, [])


    return <div>

        {errorFetchingAgencies && <ErrorMessage />}

        {loadingAgencies && <LoadingSpinner />}

        {!loadingAgencies && !errorFetchingAgencies &&
            <>
                <div className='headerRow'>
                    <div className='flex-center'>
                        <h3 className='mb-0 mr-25' ><Label color='orange'>{agencies.length}</Label> agences</h3>
                        <Select className='mr-25' placeholder='Filtrer par région' options={DropdownOptions.regionOptions} />
                        <Select className='mr-25' placeholder='Filtrer par département' options={DropdownOptions.departementsOptions} />
                        <Select className='mr-25' placeholder='Filtrer par zone' options={DropdownOptions.areaOptions} />
                    </div>
                </div>


                {
                    agencies.length === 0 ? <NoData /> :

                        <Table basic='very'>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell className="size-17">N°</Table.HeaderCell>
                                    <Table.HeaderCell className="size-17">Nom</Table.HeaderCell>
                                    <Table.HeaderCell className="size-17">Nombre de caisse</Table.HeaderCell>
                                    <Table.HeaderCell className="size-17">Compagnie</Table.HeaderCell>
                                    <Table.HeaderCell className="size-17">Date de création</Table.HeaderCell>
                                    <Table.HeaderCell className="size-17">Ville</Table.HeaderCell>
                                    <Table.HeaderCell className="size-17">Département</Table.HeaderCell>
                                    <Table.HeaderCell className="size-17"></Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>

                                {agencies.map(ag =>
                                    <Table.Row key={ag.id}>
                                        <Table.Cell>{ag.id}</Table.Cell>
                                        <Table.Cell>{ag.name}</Table.Cell>
                                        <Table.Cell>{ag.tillsCount}</Table.Cell>
                                        <Table.Cell>{ag.companyName} ({ag.companyId})</Table.Cell>
                                        <Table.Cell> {ag.createdAt?.toLocaleString()}</Table.Cell>
                                        <Table.Cell> {ag.area?.city}</Table.Cell>
                                        <Table.Cell> {ag.area?.department}</Table.Cell>
                                        <Table.Cell textAlign='right'>
                                            <Button icon className='mr-10'><Icon name='trash alternate' /></Button>
                                            <Button className='mr-10'>Plus</Button>
                                            <Button className='mr-10'><Icon name='pencil alternate' /> Éditer</Button>
                                        </Table.Cell>
                                    </Table.Row>
                                )}
                            </Table.Body>
                        </Table>
                }

            </>

        }

    </div>
}